export const ColorScales = Object.freeze({
  purple: {
    1: '#F6F2FF',
    2: '#E8DBFE',
    3: '#C7A7FD',
    4: '#A573FC',
    5: '#914BFF',
    6: '#7744D1',
    7: '#6338AE',
    8: '#502D8F',
    9: '#3A206A',
  },
  cyan: {
    1: '#E1F7FA',
    2: '#B4EBF1',
    3: '#84DEE9',
    4: '#50C8E1',
    5: '#1DB1D9',
    6: '#1796B8',
    7: '#0D6A82',
    8: '#064657',
    9: '#07313C',
  },
  green: {
    1: '#F3FEF0',
    2: '#D6F9CF',
    3: '#B0F0B8',
    4: '#78E4A5',
    5: '#4AD386',
    6: '#2EB380',
    7: '#209572',
    8: '#147362',
    9: '#095550',
  },
  blue: {
    1: '#D7DDF2',
    2: '#B0BDE3',
    3: '#899AD4',
    4: '#5C75C3',
    5: '#3350B8',
    6: '#2D479B',
    7: '#21377C',
    8: '#182A5F',
    9: '#0E1A44',
  },
  teal: {
    1: '#DCF3ED',
    2: '#BAE7DC',
    3: '#78C2BB',
    4: '#379D9B',
    5: '#008080',
    6: '#006D6D',
    7: '#085959',
    8: '#064C4C',
    9: '#033333',
  },
  orange: {
    1: '#FBE9E7',
    2: '#EECCCC',
    3: '#FD9E84',
    4: '#FD704B',
    5: '#FF551E',
    6: '#D7422F',
    7: '#BE3533',
    8: '#9D2538',
    9: '#81183E',
  },
  yellow: {
    1: '#FFFDE8',
    2: '#FFFF88',
    3: '#FFF4A2',
    4: '#FEF07E',
    5: '#FEE94E',
    6: '#E4D341',
    7: '#B1A557',
    8: '#737350',
    9: '#55503C',
  },
  grey: {
    1: '#FFFFFF',
    2: '#F4F4F4',
    3: '#D9DADC',
    4: '#BCBFC1',
    5: '#9FA4A8',
    6: '#6D767C',
    7: '#374650',
    8: '#233241',
    9: '#0F1E32',
  },
  vibrantBlue: {
    1: '#D7DDF2',
    2: '#B0BDE3',
    3: '#899AD4',
    4: '#5C75C3',
    5: '#3350B8',
    6: '#2D479B',
    7: '#21377C',
    8: '#182A5F',
    9: '#0E1A44',
  },
});
